// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"e921b70d","185":"cdf752ee","749":"f3bcbcd3"}[chunkId] + ".chunk.js";
};